module.exports = __webpack_public_path__ + "img/what-happens.e30a520b.png";